import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'redux-form';
import { RegistrationForm } from '../RegistrationForm/RegistrationForm';

const propTypes = {
    name: PropTypes.string,
    component: PropTypes.string,
    supportedLanguages: PropTypes.arrayOf(PropTypes.string),
    maMarketingConsent: PropTypes.string,
    preferredLanguage: PropTypes.string,
    locale: PropTypes.shape({
        country: PropTypes.string,
        currency: PropTypes.string,
        id: PropTypes.string,
        language: PropTypes.string,
    }),
};

const defaultProps = {
    name: 'registration',
    supportedLanguages: null,
    maMarketingConsent: null,
    preferredLanguage: null,
};

function RegistrationFormSection({ name, ...rest }) {
    return (
        <FormSection name={name}>
            <RegistrationForm component="div" {...rest} />
        </FormSection>
    );
}

RegistrationFormSection.propTypes = propTypes;
RegistrationFormSection.defaultProps = defaultProps;

export default RegistrationFormSection;
